import React, { useState, useEffect, useRef } from 'react';
import { Outlet } from 'react-router-dom';
import SidebarMain from './components/Sidebar.jsx';
import Header from './pages/Header.tsx';
import Footer from './pages/Footer';

const AuthenticatedLayout = ({ children }) => {
  const [sidebarState, setSidebarState] = useState(0); // 0: Expanded, 1: Collapsed
  const [isMobile, setIsMobile] = useState(false);
  const sidebarRef = useRef(null);
  const contentRef = useRef(null);

  const toggleSidebar = () => {
    if (isMobile) {
      setSidebarState((prevState) => (prevState === 2 ? 0 : 2));
    } else {
      setSidebarState((prevState) => (prevState === 0 ? 1 : 0)); // Only toggles between 0 and 1
    }
  };

  const closeSidebarOnLinkClick = () => {
    if (isMobile) {
      setSidebarState(2);
    }
  };

  const checkMobileView = () => {
    if (window.innerWidth <= 991) {
      setIsMobile(true);
      setSidebarState(2); // Hidden for mobile
    } else {
      setIsMobile(false);
      if (sidebarState === 2) setSidebarState(0); // Ensure sidebar is visible in desktop
    }
  };

  const handleClickOutside = (e) => {
    if (
      isMobile &&
      sidebarRef.current &&
      !sidebarRef.current.contains(e.target) &&
      !contentRef.current.contains(e.target)
    ) {
      setSidebarState(2);
    }
  };

  useEffect(() => {
    checkMobileView();
    window.addEventListener('resize', checkMobileView);
    document.addEventListener('click', handleClickOutside);

    return () => {
      window.removeEventListener('resize', checkMobileView);
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  return (
    <div className="app-container d-flex">
      <SidebarMain
        sidebarState={sidebarState}
        toggleSidebar={toggleSidebar}
        sidebarRef={sidebarRef}
        closeSidebarOnLinkClick={closeSidebarOnLinkClick}
      />
      <div className="w-100" style={{ overflow: 'hidden', backgroundColor: '#F8F9FA' }} ref={contentRef}>
        <Header
          sidebarState={sidebarState}
          toggleSidebar={toggleSidebar}
          style={{ marginLeft: sidebarState === 0 ? '250px' : '80px' }}
        />
        <div className="content-container w-100 px-3">{children}
          {/* Using Outlet to render the nested route components */}
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default AuthenticatedLayout;
